import { dmnStorage } from "../dmnStorage";

const storageKey = "gridConfig";

export type GridConfigDataStorageType = {
  displayZones: boolean;
  displayUnassigned: boolean;
  displayNewAndInProgress: boolean;
  displayLeft: boolean;
  displayNewCovers: boolean;
  displayClosedAreas: boolean;
  highlightOverrunningBookings: boolean;
  highlightOverCapacity: boolean;
  size: number;
};

export const gridConfigStorageDefault: GridConfigDataStorageType = {
  displayZones: true,
  displayUnassigned: true,
  displayNewAndInProgress: true,
  displayLeft: true,
  displayNewCovers: true,
  displayClosedAreas: true,
  highlightOverrunningBookings: true,
  highlightOverCapacity: true,
  size: 4
};

export const addGridConfigStorage = async (data: GridConfigDataStorageType) => {
  return await dmnStorage.add(storageKey, data);
};

export const getGridConfigStorage =
  async (): Promise<GridConfigDataStorageType> => {
    const response: GridConfigDataStorageType | undefined =
      await dmnStorage.get(storageKey);

    return response || gridConfigStorageDefault;
  };
